export default "__VITE_ASSET__t$4h_oI9__"